<template>
  <div class="download">
    <div class="item-container">
      <template v-if="!isInit">
        <loading :message="'読み込み中...'"></loading>
      </template>

      <p v-else-if="isInit && isError" class="aligncenter">添付ファイルの取得に失敗しました</p>
      <p v-else-if="isInit && !isError && isEmpty" class="aligncenter">添付ファイルは登録されていません</p>

      <template v-else-if="isInit && !isError">
        <download-files v-model="syainDetail.tenpufiles" name="downloadfile" :input-name="true" name-label="名称"
          :base-url="baseurl" accept=".png,.jpg,.pdf,.xlsx,.docx" @download:modelValue="fileDownload"
          @open:modelValue="fileOpenNewTab" />
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useFileDownload } from "@/composable/common/file-download";
import Config from "@/const/Config";
import { useSyainDetail } from "@/composable/syain/detail/init";
import { isEmpty } from "lodash";

export default defineComponent({
  props: {
    userId: {
      type: Object as () => number | null,
      default: null
    }
  },
  setup(props) {
    const { fileDownload, fileOpenNewTab } = useFileDownload()

    const { userId, syainDetail, getSyainDetail, setUserId } = useSyainDetail()

    const isInit = ref(false)
    const isError = ref(false)
    const isEmpty = ref(false)

    onMounted(async () => {
      if (props.userId) {
        await setUserId(props.userId)
      }

      if (userId.value) {
        await getSyainDetail(userId.value)
      } else {
        isError.value = true
      }

      if (!syainDetail.value.tenpufiles || syainDetail.value.tenpufiles?.length < 1) {
        isEmpty.value = true
      }

      isInit.value = true
    })

    return {
      fileDownload,
      fileOpenNewTab,
      syainDetail,
      baseurl: Config.THUMB_BASE_URL,
      isInit,
      isError,
      isEmpty
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>
